import { getCookie, setCookie, removeCookie } from "./cookies";
export var sendSigninPage = function (location, scrollY) {
    var header = document.querySelector('body > header');
    var loginMessage = document.querySelector('.login-message');
    var lastSection = document.querySelector('.article-section.last-section');
    var adjustH = Math.floor(scrollY - header.offsetHeight - ((loginMessage != null) ? loginMessage.offsetHeight + lastSection.offsetHeight + 32 + 100 : 0));
    var searchScroll = (location.search) ? '&setScroll=' : '?setScroll=';
    var params = (adjustH > 0) ? location.search + searchScroll + String(adjustH) : location.search;
    var pageURL = location.pathname + params + location.hash;
    setCookie('afterSignin', pageURL);
    if (adjustH > 0) {
        setCookie('setScroll', String(adjustH));
    }
    window.location.href = '/signin/';
};
export var backToAfterSignin = function () {
    var afterSignin = getCookie('afterSignin');
    removeCookie('afterSignin');
    if (afterSignin) {
        window.location.href = afterSignin;
    }
    else {
        window.location.href = '/';
    }
};
export var convertTimeFormat01 = function (time) {
    if (!time)
        return '';
    var d4 = new Date(time);
    // let d4: any = new Date(d.setMinutes(-d.getTimezoneOffset()))
    var year = d4.getFullYear();
    var month = ("0".concat(d4.getMonth() + 1)).slice(-2);
    var date = ("0".concat(d4.getDate())).slice(-2);
    var dayNum = d4.getDay();
    var day = '';
    if (dayNum === 0)
        day = '日';
    if (dayNum === 1)
        day = '月';
    if (dayNum === 2)
        day = '火';
    if (dayNum === 3)
        day = '水';
    if (dayNum === 4)
        day = '木';
    if (dayNum === 5)
        day = '金';
    if (dayNum === 6)
        day = '土';
    var hour = ("0".concat(d4.getHours())).slice(-2);
    var minute = ("0".concat(d4.getMinutes())).slice(-2);
    var second = ("0".concat(String(d4.getSeconds()))).slice(-2);
    return String("".concat(year, "/").concat(month, "/").concat(date, "(").concat(day, ") ").concat(hour, ":").concat(minute, ":").concat(second));
};
